module.exports = __webpack_public_path__ + "img/IP360.5b7d5274.png";